var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.768 7.436c1.268-1.778 12.953-4.684 14.734-3.42a4.522 4.522 0 011.726 2.914",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.282 20.29c-1.48 1.907-15.729 1.517-17.5-.124-1.615-1.494-1.58-11.258 0-12.755 1.751-1.662 15.915-1.698 17.5.123 1.299 1.493 1.164 11.255 0 12.756z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.57 15.793h-5.157a1.308 1.308 0 01-1.308-1.308v-1.239a1.307 1.307 0 011.308-1.308h5.156",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
export default SvgLoan;